import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getVendibleOptionGroups() {
    return axiosIns.get('/admin/vendible_option_groups')
  },

  createVendibleOptionGroup({
    name, position, isRequired, fieldType, vendibleOptionsAttributes,
  }) {
    const params = snakecaseKeys({
      vendibleOptionGroup: {
        name,
        position,
        isRequired,
        fieldType,
        vendibleOptionsAttributes,
      },
    })

    return axiosIns.post('/admin/vendible_option_groups', params)
  },

  updateVendibleOptionGroup({
    id, name, position, isRequired, fieldType, vendibleOptionsAttributes,
  }) {
    const params = snakecaseKeys({
      vendibleOptionGroup: {
        name,
        position,
        isRequired,
        fieldType,
        vendibleOptionsAttributes,
      },
    })

    // snakecaseKeysが_destroyをdestroyに変換してしまうため、手動で復元
    // eslint-disable-next-line no-param-reassign
    params.vendible_option_group.vendible_options_attributes.forEach(opt => {
      if (opt.destroy) {
        // eslint-disable-next-line no-param-reassign
        delete opt.destroy
        // eslint-disable-next-line no-param-reassign
        opt._destroy = true
      }
    })

    return axiosIns.put(`/admin/vendible_option_groups/${id}`, params)
  },

  deleteVendibleOptionGroup(id) {
    return axiosIns.delete(`/admin/vendible_option_groups/${id}`)
  },

  assignToVendible({ id, vendibleType, vendibleId }) {
    const params = snakecaseKeys({ vendibleType, vendibleId })

    return axiosIns.post(`/admin/vendible_option_groups/${id}/assign`, params)
  },

  unassignFromVendible({ id, vendibleType, vendibleId }) {
    const params = snakecaseKeys({ vendibleType, vendibleId })

    return axiosIns.delete(`/admin/vendible_option_groups/${id}/unassign`, { params })
  },
}
